export const tagsAction = {
  SET_TAGS: "SET_TAGS",
  SET_SECRET_KEY: "SET_SECRET_KEY",
  SET_DOMAIN_SELECT: "SET_DOMAIN_SELECT",
  SET_CURRENT_DOMAIN: "SET_CURRENT_DOMAIN",
  SET_CURRENT_TAG: "SET_CURRENT_TAG"
};
